import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { StmgService } from 'src/app/services/state_Management/stmg.service';
import { StorageServicesService } from 'src/app/services/storage_services/storage-services.service';
import { SelectionInfoComponent } from '../../../modals/selection-info/selection-info.component';
//import { allRacingbetCategories } from './all-racing-bet-catogories ';

@Component({
  selector: 'app-all-racing',
  templateUrl: './all-racing.component.html',
  styleUrls: ['./all-racing.component.scss'],
})
export class AllRacingComponent implements OnInit {

  betCat: any = [];
  allCategories: any = [];
  selectedBetCategory: any;

  clicked_item: any;
  selectedLanguage: string;

  constructor(private router: Router, 
    public modalController: ModalController, 
    public renderer: Renderer2, public ele: ElementRef,
    private storageService: StorageServicesService,
    public translate:TranslateService,
    private stmgService: StmgService) { }

  //cat: any = new allRacingbetCategories();

  ngOnInit() {
    // When refresh hide home page elements
    this.stmgService.setShowHomeElements(false);

    this.stmgService.language_status.subscribe(message => {
      this.translate.get('BET_CATEGORIES').subscribe((res: string) => {
        let index=0;
        this.categories.forEach(ele=>{
            this.categories[index].name=res[index]
            index++
        })
        this.getBetCategories();
      });
    });
    
    // select initial category as 'All Races'
    this.selectedBetCategory = this.allCategories[0];

    //load new data when main nav bar clicked
    this.stmgService.allRaceRefresh_status.subscribe(message =>{
      this.getBetCategories();
      this.selectedBetCategory = this.allCategories[0];
    });

  }

  // get Bet Categories 
  getBetCategories() {
    //this.betCat = this.cat;
    for (let i = 0; i < this.categories.length; i++) {
      this.allCategories[i] = {
        name: this.categories[i].name,
        image: this.categories[i].image,
        filter: this.categories[i].filter,
        country: this.categories[i].country,
        inplay: this.categories[i].inplay,
        active: this.categories[i].active,
        sport: this.categories[i].sport
      };
    }
  }

  viewRaceDetails() {
    console.trace("DETAIL CLICK")
    this.router.navigate(['/race_details'])
  }

  async viewInfoDetails() {
    const modal = await this.modalController.create({
      component: SelectionInfoComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

  // next10 sport categories
  switch_SportCategories(item: any, event: any) {
    if(this.selectedBetCategory==item){
      this.stmgService.nav2AllRaceRefresh('yes');
    }else{
      this.selectedBetCategory = item;
      let myTag = this.ele.nativeElement.querySelectorAll("a");
      myTag.forEach(ele => {
        ele.classList.remove('active');
      })

      //set secondary nav bar active color
      if (event.target.id == "aTag") {
        this.renderer.addClass(event.target, 'active');
      } else {
        this.renderer.addClass(event.target.parentNode, 'active');
      }
    }
  }



  categories  = [
    {
        filter: 2,
        country:'AL',
        image: '../../../assets/images/horse.png',
        inplay: false,
        name: 'All Races',
        active:true,
        sport:'RC'
    },
    {
        filter: 2,
        country:'UK',
        image: '../../../assets/images/uk.png',
        inplay: false,
        name: 'UK Racing',
        active:false,
        sport:'HR'
    },
    {
        filter: 2,
        country:'UK',
        image: '../../../assets/images/uk.png',
        inplay: false,
        name: 'UK Greyhounds',
        active:false,
        sport:'DG'
    },
    {
        filter: 2,
        country:'AU',
        image: '../../../assets/images/australia.png',
        inplay: false,
        name: 'Australia Racing',
        active:false,
        sport:'HR'
    },
    {
        filter: 2,
        country:'AU',
        image: '../../../assets/images/australia.png',
        inplay: false,
        name: 'Australia Greyhounds',
        active:false,
        sport:'DG'
    },
    {
        filter: 2,
        country:'AU',
        image: '../../../assets/images/australia.png',
        inplay: false,
        name: 'Australia Harness',
        active:false,
        sport:'HA'
    },
    {
        filter: 2,
        country:'FR',
        image: '../../../assets/images/france.png',
        inplay: false,
        name: 'France Racing',
        active:false,
        sport:'HR'
    },
    {
        filter: 2,
        country:'DEU',
        image: '../../../assets/images/germany.png',
        inplay: false,
        name: 'Germany Racing',
        active:false,
        sport:'HR'
    },
];



}
